<div class="initializing-container">
  <!-- Loading State -->
  @if (isLoading && !hasError) {
    <nz-result nzStatus="info" [nzTitle]="loadingMessage" nzSubTitle="Please wait while we set up everything for you...">
      <div nz-result-icon>
        <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
      </div>
    </nz-result>
  }

  <!-- Error State -->
  @if (hasError) {
    <nz-result [nzStatus]="errorIcon" [nzTitle]="errorTitle" [nzSubTitle]="errorMessage">
      <div nz-result-extra class="d-flex justify-content-center gap-2">
        <button nz-button nzType="primary" (click)="retry()">Retry</button>
        <button nz-button nzType="default" (click)="logout()">Back to Login</button>
      </div>
    </nz-result>
  }
</div>

